/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-29 16:15:53
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-23 10:35:56
 */
import {
  ArrowRightOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  Popover,
  Space,
  TableColumnType,
} from 'antd'
import React, { ReactElement, useState } from 'react'
import styles from './Home.module.css'

type Action = 'editCatalogue' | 'overlook'

// 已匹配的医保目录变动详情
export const Columns = (
  startIndex: number,
  onAction: (action: Action, t: any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, i) => `${startIndex + i + 1}`,
    },
    {
      title: '本地商品信息',
      width: '10rem',
      ellipsis: true,
      align: 'left',
      render: function Element(_, record) {
        return (
          <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col>
              <Popover
                content={
                  <div
                    style={{
                      height: '55px',
                    }}
                  >
                    <p
                      className={styles.nameText}
                    >
                      {record?.materialsCatalogName}
                    </p>
                    <p
                      className={styles.productText}
                    >
                      {record?.productInfo}
                    </p>
                  </div>
                }
                placement='bottom'
              >
                <div
                  style={{
                    height: '55px',
                    width: '300px',
                    overflow: 'hidden',
                  }}
                >
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '36px',
                      padding: '0',
                      margin: '0',
                      fontSize: '16px',
                      fontWeight: 'bolder',
                      color:
                        record?.status == 1 || record?.status == 2
                          ? '#CCCCCC'
                          : '#333',
                    }}
                  >
                    {record?.materialsCatalogName}
                  </p>
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '24px',
                      padding: '0',
                      margin: '0',
                      color:
                        record?.status == 1 || record?.status == 2
                          ? '#CCCCCC'
                          : '#999999',
                      fontSize: '14px',
                    }}
                  >
                    {record?.productInfo}
                  </p>
                </div>
              </Popover>
            </Col>
          </Space>
        )
      },
    },
    {
      title: '医保目录变动内容',
      dataIndex: 'changeContent',
      align: 'left',
      width: '12rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <Popover
            content={t?.records?.map((v: any, index: any) => {
              return (
                <div
                  key={index}
                >
                  <span>{v.changeRemark}&nbsp;:&nbsp;</span>
                  <span>{v.beforeChangeValue}</span>
                  <span style={{ margin: '0 6px' }}>
                    <ArrowRightOutlined style={{ color: '#FFA037' }} />
                  </span>
                  <span>{v.afterChangeValue}</span>
                </div>
              )
            })}
            placement='bottom'
          >
            {t?.records?.map((v: any, index: any) => {
              return (
                <div
                  key={index}
                  style={{
                    color:
                      t?.status == 1 || t?.status == 2 ? '#CCCCCC' : '#333',
                    textAlign: 'left',
                  }}
                >
                  <span>{v.changeRemark}&nbsp;:&nbsp;</span>
                  <span>{v.beforeChangeValue}</span>
                  <span style={{ margin: '0 6px' }}>
                    <ArrowRightOutlined style={{ color: '#FFA037' }} />
                  </span>
                  <span>{v.afterChangeValue}</span>
                </div>
              )
            })}
          </Popover>
        )
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div
            style={{
              color: t?.status == 1 || t?.status == 2 ? '#CCCCCC' : '#333',
            }}
          >
            {t?.status == '0'
              ? '待处理'
              : t?.status == '1'
              ? '已处理'
              : t?.status == '2'
              ? '已忽略'
              : ''}
          </div>
        )
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: '5rem',
      render: function action(_, t) {
        return t?.status == 1 || t?.status == 2 ? (
          <></>
        ) : (
          <Space>
            <Button
              type='link'
              size='small'
              onClick={() => {
                onAction('editCatalogue', t)
              }}
            >
              编辑目录
            </Button>
            <Button
              type='link'
              size='small'
              onClick={() => {
                onAction('overlook', t)
              }}
            >
              忽略
            </Button>
          </Space>
        )
      },
    },
  ]
}
